import { jsx as _jsx } from "react/jsx-runtime";
// Components
import { DetailParagraphComponent } from '../../../../components/detail/components/paragraph/detail-paragraph.component';
import { DetailActionsComponent } from '../../../../components/detail/components/actions/detail-actions.component';
import { DetailTagComponent } from '../../../../components/detail/components/tag/detail-tag.component';
import { DetailFigureComponent } from '../../../../components/detail/components/figure/detail-figure.component';
import { DetailFigureComplexComponent } from '../../../../components/detail/components/figure-complex/detail-figure-complex.component';
import { DetailVariantEnum } from '../../../../designSystem/reloaded/commons/components/detail';
const DetailOrchestratorComponent = ({ variant, ...props }) => {
    switch (variant) {
        case DetailVariantEnum.FIGURE_XL:
            return _jsx(DetailFigureComplexComponent, { ...props });
        case DetailVariantEnum.FIGURE_S:
            return _jsx(DetailFigureComponent, { ...props });
        case DetailVariantEnum.TAG:
            return _jsx(DetailTagComponent, { ...props });
        case DetailVariantEnum.ACTIONS:
            return _jsx(DetailActionsComponent, { ...props });
        case DetailVariantEnum.PARAGRAPH:
        default:
            return _jsx(DetailParagraphComponent, { ...props });
    }
};
export { DetailOrchestratorComponent };
//# sourceMappingURL=detail-orchestrator.component.js.map